const ZINC_ACTION_TYPES = {
  LOAD_ZINC: 'zinc/LOAD_ZINC',
};

export default ZINC_ACTION_TYPES;
